import {
  DND_CONFIGURATION_SET_LOADING,
  DND_CONFIGURATION_SET_DATA,
  DND_CONFIGURATION_SET_ERROR,
  DND_CONFIGURATION_SET_PAGINATION,
  DND_CONFIGURATION_RESET_PAGINATION,
  DND_CONFIGURATION_MAPPINGS_SET_DATA,
  DND_CONFIGURATION_MAPPINGS_SET_LOADING,
  } from 'src/actions/constants';

const defaultState = {
  isLoading: false,
  allDndConfigurations: [],
  pagination: {
    currentPageNumber: 1,
    resultPerPage: 10,
    nextOrPrev: 'first',
    lastSortedColumnValueNext : 0,
    lastSortedColumnValuePrev: 0,
    lastColumnaIdNext: 0,
    lastColumnaIdPrev: 0,
  },
  prevPagination : {
    currentPageNumber: 1,
    resultPerPage: 10,
    nextOrPrev: 'first',
    lastSortedColumnValueNext : 0,
    lastSortedColumnValuePrev: 0,
    lastColumnaIdNext: 0,
    lastColumnaIdPrev: 0,
  },
};

export default (state = defaultState, action) => {
  switch (action.type) {

    case DND_CONFIGURATION_SET_LOADING: {
      return {
        ...state,
        isLoading: action.data,
      };
    }

    case DND_CONFIGURATION_SET_DATA : {
      return {
        ...state,
        errorMessage: undefined,
        allDndConfigurations: action.data?.allDndConfigurations || [],
        activeDndConfiguration: action.data?.activeDndConfiguration || [],
      };
    }

    case DND_CONFIGURATION_MAPPINGS_SET_DATA : {
      return {
        ...state,
        errorMessage: undefined,
        allDndMappings: action.data || [],
      };
    }

    case DND_CONFIGURATION_SET_ERROR : {
      return {
        ...state,
        errorMessage: action.data,
      };
    }

    case DND_CONFIGURATION_SET_PAGINATION : {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }

    case DND_CONFIGURATION_RESET_PAGINATION: {
      return {
        ...state,
        pagination: {
          currentPageNumber : 1,
          nextOrPrev: 'first',
          resultPerPage: state.pagination.resultPerPage,
        },
      };
    }

    case DND_CONFIGURATION_MAPPINGS_SET_LOADING: {
      return {
        ...state,
        isMappingLoading: action.data,
      };
    }

    default: return state;
  }
};
